import React from 'react'
import { useTranslation } from 'react-i18next';
import { FaCrown } from "react-icons/fa";


const MessageBox = ({ text, classname, loadingHide, crown }) => {
    const { t } = useTranslation();
    return (
        <span className={`${classname || ''} ${(!text?.length && !loadingHide) ? "labelLoader square " : ""} `.trim()}>
            {t(text)} {crown && <FaCrown className='ps-1' />}
        </span>
    )
}

export default MessageBox